import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import Constants from "../common/Constants";
import { ICourtCaseConnectionType } from "../model/CourtCaseConnectionType";
import CourtCaseConnectionTypeMapper from "../service/CourtCaseConnectionTypeMapper";
import CourtCaseConnectionTypeParamMapper from "../service/CourtCaseConnectionTypeParamMapper";

export default class UpdateCourtCaseConnectionTypeInteractor {
  private resource: UpdateResourceInteractor<ICourtCaseConnectionType>;

  constructor({ updateResource }: any) {
    this.resource = updateResource;
  }

  async execute(model: ICourtCaseConnectionType) {
    const result = await this.resource.execute(
      `${Constants.courtCasesPath}/connection-types`,
      CourtCaseConnectionTypeMapper,
      CourtCaseConnectionTypeParamMapper,
      model,
      model.id
    );

    return result;
  }
}
